module.exports = __webpack_public_path__ + "img/hero_portrait_necromancer_female.8aa2e2eb.png";